import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './Header.module.css';
import routes from 'routes';

import { ReactComponent as HamburgerIcon } from 'assets/images/hamburger.svg';
// No need to import home icon anymore
//import SplitFastLogo from 'assets/images/splitfast-logo-header.png';

import SimpleClub from 'components/admin/SimpleClub';
import ClubSwitcher from 'components/admin/ClubSwitcher';
import ProfileMenu from 'components/admin/ProfileMenu';

import { getUserInfo } from 'services/auth/tokenService';

const Header = ({ openMenu, club }) => {
  const userInfo = JSON.parse(getUserInfo());

  return (
    <header className={styles.topNav}>
      <div className={styles.navLeft}>
        <button className={styles.menuToggle} onClick={openMenu}>
          <HamburgerIcon className={styles.hamburgerIcon} />
        </button>
        <Link to={routes.admin.dashboard} className={styles.homeLink}>
          <span className={styles.logoIcon}>🏠</span>
        </Link>
        <SimpleClub club={club} className={styles.clubInfo} />
        <ClubSwitcher />
      </div>
      <div className={styles.navRight}>
        <ProfileMenu
          user={userInfo}
          clubId={club.clubID}
          className={styles.profileMenu}
        />
      </div>
    </header>
  );
};

Header.propTypes = {
  openMenu: PropTypes.func,
  club: PropTypes.object,
};

export default Header;
